import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { localizeReducer } from 'react-localize-redux-dep-updated';
import { combineReducers, Reducer } from 'redux';
import { apiSettingsReducer } from '../../modules/ApiSettings/ducks';
import { generalTransport } from '../../modules/GeneralFlow/ducks';
import userReducer from '../../modules/User/ducks';
import { base } from './baseReducer';
import { notificationsReducer } from './notifications';

export default (history: History): Reducer =>
  combineReducers({
    router: connectRouter(history),
    localize: localizeReducer,
    generalTransport,
    user: userReducer,
    base,
    notifications: notificationsReducer,
    apiSettings: apiSettingsReducer,
  });
